let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eVqS8")).then(() => parcelRequire('hazUT'));